<ngx-datatable class="bootstrap core-bootstrap custom_datatable img_datatable" [rows]="rows" [rowHeight]="50"
  [count]="totalLength" [offset]="currentPage" [limit]="pageSize" [externalPaging]="true" [externalSorting]="true"
  [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
  (page)="pageChange.emit($event)" (sort)="sortChange.emit($event)">

  <!-- Dynamic columns -->
  <ngx-datatable-column *ngFor="let col of columns" [name]="col.name" [prop]="col.prop"
    [sortable]="col.sortable !== false" [width]="col.width" [headerClass]="col.headerClass" [cellClass]="col.cellClass">

    <ng-template ngx-datatable-cell-template let-row="row">
      <!-- If custom template passed: -->
      <ng-container *ngIf="col.template; else defaultCell" [ngTemplateOutlet]="col.template"
        [ngTemplateOutletContext]="{ row: row }">
      </ng-container>

      <!-- Default text cell -->
      <ng-template #defaultCell>
        {{ row[col.prop] }}
      </ng-template>
    </ng-template>

  </ngx-datatable-column>

</ngx-datatable>